import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import TextContainerField from "../../../components/TextContainerField";
import { ArrowBack } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { fetchDataById } from "../../../api/Services";
import Spinner from "../../../components/Spinner";

const ViewMotorVariant = () => {
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [variantData, setVariantData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setIsLoading(true);
        try {
          await fetchDataById(`/reference/motor/mmv/variant/${paramId}`).then(
            (res) => {
              console.log("api", res?.data);
              setVariantData((prevData) => ({
                ...prevData,
                ...res?.data,
              }));
            }
          );
        } catch (err) {
          console.log(err);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  if (isLoading) {
    return (
      <DashboardLayout>
        <Spinner />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          padding: { xs: 2, md: 2 },
          bgcolor: "#f9f9f9",
          minHeight: "100vh",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="left"
          spacing={1}
          mb={2}
        >
          <IconButton onClick={() => window.history.back()}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
            Motor Variant Information
          </Typography>
        </Stack>

        {variantData ? (
          <Grid container spacing={3} sx={{ mx: { xs: 0, md: 2 } }}>
            <Grid xs={12} sm={6} md={4} sx={{ width: "100%" }}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                    {variantData?.name}
                  </Typography>
                  <TextContainerField
                    label="Launch Year"
                    value={variantData?.launchYear}
                  />
                  <TextContainerField
                    label="Vehicle Category"
                    value={variantData?.motorCategory?.name}
                  />
                  <TextContainerField
                    label="Motor Model"
                    value={variantData?.motorModel?.name}
                  />
                  <TextContainerField
                    label="Motor Model ID"
                    value={variantData?.motorModelId}
                  />
                  <TextContainerField
                    label="Fuel Type ID"
                    value={variantData?.fuelType?.id}
                  />
                  <TextContainerField
                    label="Engine Capacity"
                    value={variantData?.engineCapacity + " cc"}
                  />
                  <TextContainerField
                    label="Seat Capacity"
                    value={variantData?.seatCapacity + " seats"}
                  />
                  <TextContainerField
                    label="Carrying Capacity"
                    value={variantData?.carryingCapacity + " kg"}
                  />
                  <TextContainerField
                    label="Body Type"
                    value={variantData?.bodyType?.name}
                  />
                  <TextContainerField
                    label="Body Style"
                    value={variantData?.bodyStyleId}
                  />
                  <TextContainerField
                    label="Wheels"
                    value={variantData?.wheels}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Box>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                color: "red",
                fontFamily: "cursive",
              }}
            >
              No Motor Variant Data Found
            </Typography>
          </Box>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default ViewMotorVariant;
